import React, { useState, useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";
import ladyRun from "../../images/ladyRun.png";

export const AthletePurchaseStaticStrengthTemplates = () => {
  const { athlete } = useAthleteAuthContext();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch strength products dynamically from new API
  const fetchProducts = async () => {
    try {
      const response = await fetch(API_URL.FRONTEND_STRENGTH_ALL_PRODUCTS, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${athlete.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();

      if (result?.data) {
        setProducts(result.data);
      } else {
        setProducts([]);
      }
    } catch (err) {
      setError(err.message);
      console.error("Error fetching strength products:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (athlete?.token) {
      fetchProducts();
    }
  }, [athlete?.token]);

  return (
    <AthleteLayout>
      <div className="h-full overflow-y-auto bg-white">
        <div className="w-full max-w-2xl mx-auto px-5">
          {/* Back button */}
          <div className="py-5 w-full max-w-96 mx-auto">
            <Link
              to="/athlete/tools"
              className="flex items-center gap-2 text-black text-base hover:opacity-70 transition-all"
            >
              <span className="w-2 h-2 border-[1.5px] border-black border-solid rotate-45 border-t-0 border-r-0"></span>
              Back
            </Link>
          </div>

          <div
            className="tabbing w-full max-w-96 mx-auto"
            id="default-tab-content"
          >
            {/* Tab header */}
            <div className="flex flex-row justify-center text-center mb-2">
              <div className="w-1/2 pr-1.5">
                <Link to="/athlete/purchase/static-speed-templates">
                  <p className="text-base pb-2.5 cursor-pointer text-lightSmock  border-b border-smock">
                    Speed
                  </p>
                </Link>
              </div>

              <div className="w-1/2 pl-1.5">
                <p className="text-base pb-2.5 cursor-pointer text-black  border-b-2 border-darkYellow">
                  Strength
                </p>
              </div>
            </div>

            {/* Loading / Error / Product Display */}
            {loading ? (
              <div className="text-center py-5">
                <p>Loading strength programs...</p>
              </div>
            ) : error ? (
              <div className="text-center py-5">
                <p className="text-red-500">Error: {error}</p>
              </div>
            ) : products.length === 0 ? (
              <div className="text-center py-5">
                <p>No strength programs found.</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-x-3 gap-y-5 py-3">
                {products.map((product) => (
                  <Link
                    to={`/athlete/purchase/static-strength-template-detail/${product._id}`}
                    className="block rounded-b-xl hover:shadow-md"
                    key={product._id}
                  >
                    <div className="flex flex-col">
                      <div className="aspect-square rounded-xl overflow-hidden">
                        <img
                          src={
                            product.image
                              ? `${API_URL.SERVER_PICTURE_URL}${product.image}`
                              : ladyRun
                          }
                          alt={product.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="p-2 xs:p-3 space-y-1">
                        <p className="text-black text-sm leading-tight capitalize line-clamp-2 min-h-[1.3rem]">
                          {product.title}
                        </p>
                        <span className="text-black text-sm xs:text-base font-light">
                          ${product.price}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
